import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { OnboardingLinkAddon } from 'voxloud-types/dist/models';

@Component({
  selector: 'gdp-activation-link-addon-card',
  templateUrl: './activation-link-addon-card.component.html',
  styleUrls: ['./activation-link-addon-card.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ActivationLinkAddonCardComponent),
      multi: true
    }
  ]
})
export class ActivationLinkAddonCardComponent implements ControlValueAccessor {
  @Input() canRemove: boolean = false;
  @Input() name: string = '';
  @Input() subtitle: string = '';
  @Input() min: number = 1;
  @Input() max?: number;

  @Output() remove: EventEmitter<void> = new EventEmitter();

  addon: OnboardingLinkAddon;
  disabled = false;

  private onChange: (value: OnboardingLinkAddon) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: OnboardingLinkAddon): void {
    if (value !== null && value !== undefined) {
      this.addon = value;
    }
  }

  registerOnChange(fn: (value: OnboardingLinkAddon) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  updateValue(newValue: number): void {
    if(!this.addon) return;
    this.addon = {
      ...this.addon,
      quantity: newValue
    };
    this.onChange(this.addon);
    this.onTouched();
  }

  onRemoveClicked() {
    this.remove.emit();
  }
}